import { safeString, stringOrUndefined } from 'helper/common'
import { VendorDetailsForm } from './types'
import {
  VendorDetails,
  VendorUpdatePayload,
  VendorWithAdminCreationRequestData
} from '../../types'
import { COUNTRIES_LIST } from '../../constants'
import { getZipCodeByCountry } from '../VendorForm/utils'

export const convertDetailsToForm = (
  details: VendorDetails,
  isStakeholder?: boolean
): VendorDetailsForm => ({
  vendor: {
    name: safeString(details.name),
    business_name: safeString(details.business_name),
    business_type: stringOrUndefined(details.business_type),
    description: safeString(details.description),
    phone_number: stringOrUndefined(details.phone_number)?.replace('+1', ''),
    address: {
      street: stringOrUndefined(details.address?.street),
      city: stringOrUndefined(details.address?.city),
      state: stringOrUndefined(details.address?.state),
      zip_code: getZipCodeByCountry(
        stringOrUndefined(details.address?.zip_code),
        details.address?.country || COUNTRIES_LIST[0].value
      ),
      country: details.address?.country || COUNTRIES_LIST[0].value
    },
    vendor_permission:
      details.vendor_permission || (isStakeholder ? 'guest' : 'full_access')
  },
  remit_to_address_set: details.remit_to_address_set?.map((address) => ({
    ...address,
    country: address.country || COUNTRIES_LIST[0].value,
    zip_code:
      getZipCodeByCountry(
        address.zip_code,
        address.country || COUNTRIES_LIST[0].value
      ) || address.zip_code
  })),
  order_from_address_set: details.order_from_address_set?.map((address) => ({
    ...address,
    country: address.country || COUNTRIES_LIST[0].value,
    zip_code:
      getZipCodeByCountry(
        address.zip_code,
        address.country || COUNTRIES_LIST[0].value
      ) || address.zip_code
  })),
  alternate_name_set: details.alternate_name_set && [
    ...details.alternate_name_set
  ]
})

export const convertFormToCreationDetails = (
  form: VendorDetailsForm
): VendorWithAdminCreationRequestData => {
  const requestData: VendorWithAdminCreationRequestData = {
    business_name: form.vendor.business_name,
    vendor_permission: form.vendor.vendor_permission,
    business_type: form.vendor.business_type
  }
  if (form.vendor.name) {
    requestData.name = form.vendor.name
  }
  const { street, city, state, zip_code } = form.vendor.address || {}
  if (street || city || state || zip_code) {
    requestData.address = form.vendor.address
  }
  if (form.vendor.description) {
    requestData.description = form.vendor.description
  }

  if (form.vendor.phone_number) {
    const number = !form.vendor.phone_number?.toString()?.includes('+1')
      ? '+1' + form.vendor.phone_number
      : form.vendor.phone_number
    requestData.phone_number = number
  }
  if (form.alternate_name_set) {
    requestData.alternate_name_set = form.alternate_name_set
  }
  if (form.order_from_address_set) {
    requestData.order_from_address_set = form.order_from_address_set
  }
  if (form.remit_to_address_set) {
    requestData.remit_to_address_set = form.remit_to_address_set
  }
  return requestData
}

export const convertDataToUpdateDetails = (
  form: VendorDetailsForm
): VendorUpdatePayload => {
  const parsedRequestData = convertFormToCreationDetails(form)
  // setting values as empty string if no value was set
  // backend expect empty string value for put request
  return {
    ...parsedRequestData,
    phone_number: parsedRequestData.phone_number || '',
    description: parsedRequestData.description || '',
    address: parsedRequestData.address || null
  }
}
